var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHome(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 25,
    viewBox: "0 0 30 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.416378 0.103848C0.305778 0.153074 0.162648 0.251532 0.104095 0.331526C0.00650591 0.460751 0 1.45146 0 12.0232V23.5672L0.136624 23.7272C0.208189 23.8195 0.377343 23.9179 0.507461 23.9548C0.670109 23.9979 2.02984 24.0164 4.68426 24.0041L8.62033 23.9856V12.017V0.0484657L4.6192 0.0361576C1.35974 0.0238514 0.579026 0.0361576 0.416378 0.103848Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.9868 0.0921974C9.96728 0.135272 9.96078 2.68898 9.96728 5.77188L9.9868 11.3716L19.6351 11.39L29.2768 11.4023V5.93803C29.2768 -0.123176 29.3094 0.282956 28.8474 0.104505C28.5417 -0.0185652 10.0323 -0.0247192 9.9868 0.0921974Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.9868 12.705C9.96728 12.7481 9.96078 15.3018 9.96728 18.3847L9.9868 23.9844H14.6385H19.2903V18.3231V12.6619L14.6515 12.6435C10.9757 12.6312 10.0063 12.6435 9.9868 12.705Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M20.6365 18.3059L20.6561 23.9856L24.5921 24.0041C27.2466 24.0164 28.6063 23.9979 28.7689 23.9548C28.8991 23.9179 29.0682 23.8195 29.1398 23.7272C29.2764 23.5733 29.2764 23.5241 29.2764 18.1029V12.6324H24.95H20.6235L20.6365 18.3059Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHome);
export default __webpack_public_path__ + "static/media/home.ebab91226966b98aa1b419289bb14b8d.svg";
export { ForwardRef as ReactComponent };